import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    titulo: {
        color: theme.palette.primary.main,
        fontWeight: 500,
        marginBottom: theme.spacing(1),
        '& span': {
            fontWeight: 600
        }
    },
    labelPrimary: {
        '& span': {
            fontWeight: 600,
            fontSize: '1.4rem'
        }
    },
    tarefasContainer: {
    },
    tarefas: {
    },
    titleAccordion: {
        width: '100%',
    },
    contentDataVersao: {
        gap: theme.spacing(.5),
        marginBottom: theme.spacing(.5),
        display: 'flex',
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        padding: theme.spacing(0, 2) + ' !important',
    },
    dataTarefa: {

    },
}))